export default __webpack_public_path__ + "static/media/wsp.9edc0faf.svg";